import { FilterTypesEnum } from "../filters/filterTypes.enum";
import { ISelectOption } from "./selectOption.interface";

export const CreationTimeSinceOptions: ISelectOption[] = [
    {
        id: `${FilterTypesEnum.CreationTimeSinceDate.toString()}-30`,
        value: "30",
        displayName: "30 Days",
        categoryName: FilterTypesEnum.CreationTimeSinceDate.toString(),
        filterType: FilterTypesEnum.CreationTimeSinceDate,
    },
];
